import { ModalsService } from './../../../_core/services/modals.service';
import { Component, OnInit } from '@angular/core';
import { Configuration } from 'src/app/app.constants';

@Component({
  selector: 'app-embedded-donate-button',
  templateUrl: './embedded-donate-button.component.html',
  styleUrls: ['./embedded-donate-button.component.scss'],
})
export class EmbeddedDonateButtonComponent implements OnInit {
  public buttonHtmlCode: string;

  link: string;
  // Read from the tenant's environment rather than hardcoded: these two were the SWISS
  // NetSuite media URLs, so every tenant's embed modal handed out TrustBridge-branded
  // buttons -- GLF and IGF users included. DonateButtonsComponent already sources the
  // same pair from Configuration; this now matches it.
  lightButtonPath: string;
  darkButtonPath: string;

  constructor(private modalService: ModalsService, private config: Configuration) {
    this.lightButtonPath = this.config.lightDonateNowButtonLink;
    this.darkButtonPath = this.config.darkDonateNowButtonLink;
  }

  ngOnInit(): void {
    this.link = this.modalService.params.donateLink;
  }

  close() {
    this.modalService.closeModal();
  }

  onSelectButton(event) {
    if (event === 'light') {
      this.buttonHtmlCode = `<a target="_blank" href="${this.link}"><img src="${this.lightButtonPath}"/></a>`;
    } else {
      this.buttonHtmlCode = `<a target="_blank" href="${this.link}"><img src="${this.darkButtonPath}"/></a>`;
    }
  }
}
